import I18N from '@s-ui/i18n'
import Polyglot from '@s-ui/i18n/lib/adapters/polyglot.js'
import cookie from '@s-ui/js/lib/cookie'
import {parseQueryString, toKebabCase} from '@s-ui/js/lib/string'
import {Coches, Motos} from '@adv-mt/mt-domain'

import {getDeviceStats} from '../helpers/getDeviceStats.js'

const DEFAULT_CULTURE = 'es-ES'
const DEFAULT_CURRENCY = 'EUR'
const WEBVIEW_QUERY_PARAM = 'nc'

const DESKTOP = 'desktop'
const MOBILE = 'mobile'
const TABLET = 'tablet'

function setCookie(name, value, days) {
  if (typeof window === 'undefined') {
    return
  }

  let expires = ''

  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 3600 * 1000)
  expires = '; expires=' + date.toUTCString()

  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export default async ({cookies = '', isMotos, isClient, logger, req = {}, userAgent}) => {
  const {isMobile, isTablet, osName = '', browserName} = getDeviceStats(userAgent)

  const referer =
    (isClient && document.referrer !== '' && document.referrer) ||
    (isClient && window.location.href) ||
    req.headers.referrer ||
    req.headers.referer

  const url = isClient
    ? window.location.href
    : req?.protocol && req?.get
    ? `${req.protocol}://${req.get('host')}${req.originalUrl}`
    : `http://localhost${req?.originalUrl || '/'}`

  const isWebview = Boolean(
    isClient ? parseQueryString(window.location.search)?.[WEBVIEW_QUERY_PARAM] : req.query[WEBVIEW_QUERY_PARAM]
  )

  const {parse} = cookie
  // Coches is the default for every domain except motos.net (localhost for example)
  const domain = isMotos ? new Motos(logger) : new Coches(logger)
  const config = domain.get('config')
  const {URL, REFERER} = config.get('REQUEST_HEADERS')

  domain.config('cookie', parse(cookies))
  domain.config('isMobile', isMobile)
  domain.config('isTablet', isTablet)
  domain.config('osName', toKebabCase(osName.toLowerCase()))
  domain.config('browserName', browserName)
  domain.config('isWebview', isWebview)
  // Config param used to identify requests in the domain.
  // Was created for Axios monitoring with sui-perf
  domain.config('serverRequestId', req.reqId)

  // Request Header for A/B test Backend
  domain.config(REFERER, referer)
  domain.config(URL, url)

  // This should be removed in https://jira.scmspain.com/browse/MTR-13997
  setCookie('cfg', 1, 1)

  const getLiterals = () => domain.get('get_language_literals_use_case').execute()
  const getCurrentUser = () => domain.get('get_current_user_use_case').execute()

  const [{value: literals}, {value: currentUser}] = await Promise.allSettled([getLiterals(), getCurrentUser()])

  const i18n = new I18N({adapter: new Polyglot({allowMissing: process.env.NODE_ENV === 'production'})})

  i18n.languages = literals
  i18n.culture = DEFAULT_CULTURE
  i18n.currency = DEFAULT_CURRENCY
  i18n.defaultNumberFormatOptions = {useGrouping: true}

  return {
    cookies,
    i18n,
    domain,
    browser: {
      // eslint-disable-next-line no-nested-ternary
      browserName,
      deviceType: isMobile ? MOBILE : isTablet ? TABLET : DESKTOP,
      osName,
      userAgent
    },
    userAgent,
    user: currentUser
  }
}
